import { render, staticRenderFns } from "./AssetPackage.vue?vue&type=template&id=a31734dc"
import script from "./AssetPackage.vue?vue&type=script&lang=js"
export * from "./AssetPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports